import React from "react";
export default function LoadingButton({
                                          loading = false,
                                          text = "Execute",
                                          loadingText = "Please Wait...",
                                          className = "btn btn-primary",
                                          onClick,
                                          disabled = false
                                      }) {
    return (
        <button

            className={className}

            disabled={loading || disabled}

            onClick={onClick}

        >

            {
                loading ?
                    <>

                        <span

                            className="spinner-border spinner-border-sm me-2"

                            role="status"

                        />

                        {loadingText}

                    </>
                    :
                    text
            }

        </button>
    );
}